module.exports = __webpack_public_path__ + "static/media/cycle-icon5.90583e42.svg";